var map = {
  "./da.json": [
    "22912",
    [
      80665
    ]
  ],
  "./fi.json": [
    "76642",
    [
      22431
    ]
  ],
  "./sv.json": [
    "30802",
    [
      73679
    ]
  ],
  "./ja.json": [
    "58406",
    [
      47275
    ]
  ],
  "./lt.json": [
    "74215",
    [
      76044
    ]
  ],
  "./sl.json": [
    "83048",
    [
      44081
    ]
  ],
  "./fr.json": [
    "41691",
    [
      62856
    ]
  ],
  "./es.json": [
    "12655",
    [
      82980
    ]
  ],
  "./no.json": [
    "19204",
    [
      5701
    ]
  ],
  "./cs.json": [
    "39161",
    [
      46722
    ]
  ],
  "./en.json": [
    "87272",
    [
      32625
    ]
  ],
  "./description/en.json": [
    "51223",
    [
      13916
    ]
  ],
  "./pl.json": [
    "27267",
    [
      6848
    ]
  ],
  "./hu.json": [
    "97280",
    [
      14969
    ]
  ],
  "./nl.json": [
    "60945",
    [
      54314
    ]
  ],
  "./de.json": [
    "72252",
    [
      7693
    ]
  ],
  "./pt.json": [
    "5675",
    [
      85112
    ]
  ],
  "./it.json": [
    "69862",
    [
      88683
    ]
  ],
  "./et.json": [
    "35026",
    [
      62223
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 83914;
module.exports = __rspack_async_context;
